var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { FormContainer, GeneralErrorText } from './styles';
import { BuildingInformationSection, ServiceRequestSection, TicketManagementSection } from 'src/Components';
import { useTicketForm, validateInternalTicketForm } from '../shared';
import { useTicketAlerts } from '../shared/hooks/useTicketAlerts';
import { TicketAlertsModal } from '../TicketAlertsModal';
import { FormGrid } from '../TicketForm/styles';
import Cookies from 'js-cookie';
import { TYPE_CONTACT } from 'src/Utils/constants';
export var InternalTicketForm = function (_a) {
    var buildingId = _a.buildingId, onSubmittingChange = _a.onSubmittingChange;
    var isContact = Cookies.get('User') === TYPE_CONTACT;
    var initialFormData = {
        internal: true,
        building_id: buildingId !== null && buildingId !== void 0 ? buildingId : null,
        building_code: '',
        tower_id: null,
        tower_code: '',
        apartment_id: null,
        apartment_number: '',
        relation: '',
        title: '',
        provider_service: '',
        description: '',
        assignee_id: null,
        communication_channel: 'phone'
    };
    var _b = useTicketForm({
        initialFormData: initialFormData,
        isInternal: true,
        customValidation: validateInternalTicketForm
    }), _c = _b.formState, formData = _c.formData, errors = _c.errors, isSubmitting = _c.isSubmitting, _d = _b.formActions, handleInputChange = _d.handleInputChange, handleSubmit = _d.handleSubmit, setFormData = _d.setFormData, buildings = _b.buildings, towers = _b.towers, apartments = _b.apartments;
    var alertsBuildingId = isContact ? null : formData.building_id;
    var alertsApartmentId = isContact ? null : formData.apartment_id;
    var _e = useTicketAlerts({
        buildingId: alertsBuildingId,
        apartmentId: alertsApartmentId,
        buildings: buildings,
        apartments: apartments,
    }), alertModal = _e.alertModal, closeAlertModal = _e.closeAlertModal;
    useEffect(function () {
        if (onSubmittingChange) {
            onSubmittingChange(isSubmitting);
        }
    }, [isSubmitting, onSubmittingChange]);
    useEffect(function () {
        if (buildingId != null && buildings.length > 0 && !formData.building_code) {
            var selectedBuilding_1 = buildings.find(function (building) { return building.id === buildingId; });
            if (selectedBuilding_1) {
                setFormData(function (prev) { return (__assign(__assign({}, prev), { building_id: buildingId, building_code: selectedBuilding_1.code || '' })); });
            }
        }
    }, [buildingId, buildings, formData.building_code, setFormData]);
    useEffect(function () {
        onSubmittingChange === null || onSubmittingChange === void 0 ? void 0 : onSubmittingChange(isSubmitting);
    }, [isSubmitting, onSubmittingChange]);
    return (React.createElement(FormContainer, { id: "internal-ticket-form", onSubmit: function (e) {
            e.preventDefault();
            if (isSubmitting)
                return;
            handleSubmit();
        } },
        React.createElement(FormGrid, null,
            React.createElement(BuildingInformationSection, { formData: {
                    building_id: formData.building_id,
                    building_code: formData.building_code,
                    tower_id: formData.tower_id,
                    tower_code: formData.tower_code,
                    apartment_id: formData.apartment_id,
                    apartment_number: formData.apartment_number,
                    relation: formData.relation
                }, buildings: buildings, towers: towers, apartments: apartments, errors: errors, onInputChange: handleInputChange }),
            React.createElement(TicketManagementSection, { style: {
                    gridRow: '1 / span 2',
                    gridColumn: 2
                }, formData: {
                    assignee_id: formData.assignee_id
                }, onInputChange: handleInputChange }),
            React.createElement(ServiceRequestSection, { formData: {
                    title: formData.title,
                    provider_service: formData.provider_service,
                    description: formData.description,
                    communication_channel: formData.communication_channel
                }, errors: errors, onInputChange: handleInputChange })),
        errors.general && (React.createElement(GeneralErrorText, null, errors.general)),
        !isContact && (React.createElement(TicketAlertsModal, { isOpen: alertModal.isOpen, onClose: closeAlertModal, alerts: alertModal.alerts, buildingName: alertModal.buildingName, apartmentNumber: alertModal.apartmentNumber }))));
};
export default InternalTicketForm;
